import Noty from "noty";
import "../../../node_modules/noty/lib/noty.css";
import "../../../node_modules/noty/lib/themes/bootstrap-v4.css";

export function notificationKardexProductoNull() {
    new Noty({
      type: "warning",
      theme: "bootstrap-v4",
      layout: "topCenter",
      text: "SELECCIONAR UN PRODUCTO",
      timeout: 3000
    }).show();
}

export function notificationKardexFechas() {
    new Noty({
      type: "warning",
      theme: "bootstrap-v4",
      layout: "topCenter",
      text: "LA FECHA Y HORA DE FIN DEBE SER MAYOR O IGUAL A LA FECHA Y HORA DE INICIO",
      timeout: 3000
    }).show();
}

export function notificationStockInicial() {
  new Noty({
    type: "success",
    theme: "bootstrap-v4",
    layout: "topCenter",
    text: "CANTIDAD AGREGADA",
    timeout: 3000
  }).show();
}